/*
This script continously loads post as the user scrolls the page. It uses the IntersectionObserver API to detect when the last post is in view. When the last post is in view, it fetches the next page and appends the posts to the page. It then checks if there is a next page and if there is, it continues to observe the last post. If there is no next page, it disconnects the observer. 

Importantly, for this script to work, it requires that each card have the `post` class and that the card container have the `gh-postfeed` class
*/
import { MasonryInfiniteGrid } from '@egjs/infinitegrid';

let link = document.querySelector('link[rel="next"]')?.getAttribute('href');

// Fetch and parse next page
async function getNextPage(url) {
    try {
        const res = await fetch(url);

        if (!res.ok) {
            throw new Error('Failed to fetch page');
        }

        const nextPageHtml = await res.text();
        const parser = new DOMParser();
        const parsed = parser.parseFromString(nextPageHtml, 'text/html');
        const posts = parsed.querySelectorAll('.post');
        const nextLink = parsed
            .querySelector('link[rel="next"]')
            ?.getAttribute('href');

        return { posts, nextLink };
    } catch (error) {
        throw new Error(error);
    }
}

function infiniteScroll() {
    const ig = new MasonryInfiniteGrid('.gh-postfeed', {
        useResizeObserver: true,
        observeChildren: true,
    });

    ig.on('requestAppend', (e) => {
        if (!link) {
            ig.off('requestAppend');
            return;
        }
        ig.wait();
        getNextPage(link).then(({ posts, nextLink }) => {
            link = nextLink;
            ig.append([...posts]);
            ig.ready(posts.length === 0); // hasNoItems will probably never be true
        });
    });

    ig.renderItems();
}

infiniteScroll();
